import axios from "axios";
import { serviceUrl } from "../../config";
import { getSessionData } from "../utilfunctions/utilFunctions";

const BACKEND_URL = serviceUrl;

let resetSessionFn = null;

export const setResetSession = (fn) => {
  resetSessionFn = fn;
};

export const resetSession = () => {
  if (resetSessionFn) {
    resetSessionFn();
  } else {
    console.error("resetSession function is not set yet.");
  }
};

export const checkSession = async (userid) => {
    try {
    const sessionData = getSessionData();
      const data = JSON.stringify({
        svc: "sessions",
        pid: "checkSession",
        dat: {
            ...sessionData
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };